/* @flow */

// Ref: https://martinfowler.com/articles/feature-toggles.html

// Experiment features
export const onboardingIntroAFeature = 'onboarding_intro_a';
export const marketPromptsFeature = 'market_prompts';
export const helpFeature = 'help';
export const githubProfileFeature = '18.11_github_profile';
export const manualAvailabilityFeature = '19.06_manual_availability';
export const interestsFeature = 'add_interests_v0';
export const lightThemeFeature = 'light_theme';
export const videoCallFeedbackFeature = '20.07_video-call-feedback';
export const improvedTopicCardFeature = '20.07_improved-topic-card';

// Integration features
export const disableLoginLinkFeature = 'disable_login_link';
export const profileEditionBraindateOnly = 'profile_edition_braindate_only';
export const hideAccountPrefsFeature = '18.10_hide_account_prefs';

// Plugins
export const emailPlugin = 'email';
export const smsPlugin = 'sms';
export const signupPlugin = 'signup';
export const selfCheckInPlugin = 'self_checkin';
export const slackPlugin = 'slack';
export const topicDisclaimerPlugin = 'topic_disclaimer';
export const googleSyncPlugin = 'google-calendar';
export const outlookSyncPlugin = 'microsoft-outlook';
export const doubleDutchPlugin = 'doubledutch';
export const ssoPlugin = 'sso';
export const moderationPlugin = 'moderation';
export const klikPlugin = 'klik_profile';
export const backToAppPlugin = '19.04_back_to_app_link';
export const customMenuPlugin = 'custom_menu';
export const onboardingCustomTextPlugin = '19.05_onboarding_custom_text';
export const customFontPlugin = '19.07_custom_font';
export const videoCallPlugin = 'video-call';
export const videoCallPluginProviderTeams = 'microsoft-teams';
export const videoCallPluginProviderTwilio = 'twilio';

// Integration plugins
export const avatarUploadPlugin = '19.08_avatar_upload';
